export const mergeProfesionales = (legajos, gastos, asistencias) => {
  const profLegajos = legajos.map((l) => ({ id: l.IdUsuario, name: l.Usuario }));
  const profGastos = gastos.map((g) => ({
    id: g.idUsuario,
    name: g.usuario,
  }));
  const profAsist = asistencias.map((a) => ({
    id: a.asignado,
    name: a.usuario,
  }));

  const all = [...profLegajos, ...profGastos, ...profAsist];
  const unique = Array.from(new Map(all.map((p) => [p.id, p])).values());
  return unique;
};